//@flow

import React, { useState } from 'react';

import { AppZapTemplates } from '@zapier/design-system-app-profiles';
import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/common-components';

import ApolloQuery from 'web-ssr/app/common/components/ApolloQuery';
import appZapTemplatesQuery from 'web-ssr/app/app-directory/components/AppZapTemplates/appZapTemplatesQuery';
import { GLOBAL_APP_COUNT } from 'web-ssr/app/common/constants';

import type { appZapTemplatesQuery as appZapTemplatesQueryType } from 'web-ssr/graphql/types';

type Props = {
  primaryAppSlug: string,
};

type Result = {
  loading: *,
  fetchMore: *,
  error: *,
  data: appZapTemplatesQueryType,
};

const AppZapTemplatesContainer = ({ primaryAppSlug }: Props) => {
  const layoutProps = useMediaProps({
    [Screen.queries.phone]: { size: 'small', zapConnectorSize: 'medium' },
    [Screen.queries.phablet]: { size: 'small', zapConnectorSize: 'medium' },
    [Screen.queries.tablet]: { size: 'medium', zapConnectorSize: 'large' },
    [Screen.queries.desktop]: { size: 'large', zapConnectorSize: 'large' },
  });

  const [secondaryApp, setSecondaryApp] = useState(null);

  return (
    <ApolloQuery
      query={appZapTemplatesQuery}
      variables={{ appSlug: primaryAppSlug }}
    >
      {({ data }: Result) => {
        const { appBySlug } = data || {};

        if (!appBySlug) {
          return null;
        }

        return (
          <AppZapTemplates
            onSelectApp={setSecondaryApp}
            primaryApp={appBySlug}
            secondaryApp={secondaryApp}
            size={layoutProps.size}
            title={`Connect ${appBySlug.name} to ${GLOBAL_APP_COUNT}+ Apps`}
            zapConnectorSize={layoutProps.zapConnectorSize}
          />
        );
      }}
    </ApolloQuery>
  );
};

export default AppZapTemplatesContainer;
